// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(/css/table.css);"]);
// Module
exports.push([module.id, "\ndiv.assoc-table-bottom-line[data-v-34fed648] table.table-sm th:first-child,\ndiv.assoc-table-bottom-line[data-v-34fed648] table.table-sm td:first-child {\n    width: 10px;\n    max-width: 10px;\n    padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
